var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36377 13.875H2.86377M2.86377 13.875H10.3638M2.86377 13.875V3.52515C2.86377 2.68507 2.86377 2.26472 3.02726 1.94385C3.17107 1.6616 3.40037 1.4323 3.68262 1.28849C4.00348 1.125 4.42384 1.125 5.26392 1.125H7.96392C8.80399 1.125 9.22345 1.125 9.54432 1.28849C9.82656 1.4323 10.0566 1.6616 10.2004 1.94385C10.3638 2.2644 10.3638 2.68425 10.3638 3.52268V7.875M10.3638 13.875H14.8638M10.3638 13.875V7.875M14.8638 13.875H16.3638M14.8638 13.875V7.875C14.8638 7.17609 14.8637 6.8268 14.7495 6.55115C14.5973 6.18361 14.3055 5.89142 13.938 5.73918C13.6623 5.625 13.3125 5.625 12.6136 5.625C11.9147 5.625 11.5652 5.625 11.2896 5.73918C10.922 5.89142 10.6302 6.18361 10.478 6.55115C10.3638 6.8268 10.3638 7.17609 10.3638 7.875M5.11377 6.375H8.11377M5.11377 4.125H8.11377",
    stroke: "#2B48AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency);
export default __webpack_public_path__ + "static/media/agency.1ffd085925568d595e785d2a928ee650.svg";
export { ForwardRef as ReactComponent };